import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { JobService } from 'src/app/services/job/job.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-count-wages',
  templateUrl: './count-wages.component.html',
  styleUrls: ['./count-wages.component.scss']
})
export class CountWagesComponent {
  public addForm!: FormGroup;
  public categoryArr: any[] = [];
  public subCategoryArr: any[] = [];
  public filterEmployeeArr: any[] = [];
  public filterRecArr: any[] = [];
  public filterCmp:any[]=[];
  public userType!: string;

  constructor(private fb: FormBuilder, private appService: AppService, private recruiterService: RecruiterService,
  private commonService: CommonService,private jobService:JobService,private datePipe:DatePipe) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    this.addForm = this.fb.group({
      'st_dt': ['', Validators.required],
      'ed_dt': ['', Validators.required],
      'j_c': "",
      'j_sc': "",
      'rec': "",
      'cmp': "",
      'emp': "",
      'type': "",
    })

    const userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    // this.userType = userInfo.u_typ == 0 ? 'company' : 'recruiter';
    this.userType = userInfo.u_typ == 0 ? 'company' : (userInfo.u_typ == 1 ? 'recruiter' : 'admin');

    this.getCategoryList()
    this.onCallAPI()
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  getCategoryList() {
    this.recruiterService.getCategoryList({}).subscribe({
      next: (success: any) => {
        this.categoryArr = [];
        this.subCategoryArr = [];
        if (success.msg) {
          this.categoryArr = success.msg;
          this.subCategoryArr = [];
          // this.subCategoryArr = this.categoryArr[0].sub_category;
          // this.setViewData()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSelectCategory(event) {
    let catItem = this.categoryArr.find((item) => item.j_c == event.value);
    this.subCategoryArr = [];
    this.addForm.get('j_sc')?.setValue('')
    if (catItem) {
      this.subCategoryArr = catItem.sub_category;
    }
  }
  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.first_name.toLowerCase().indexOf(term) > -1 || item.last_name.toLowerCase().indexOf(term) > -1;
  }
  getEmpList() {
    //time sheet value 
  }
  onCallAPI() {
    this.jobService.getUserDetail({}).subscribe({
      next: (success: any) => {
        this.filterEmployeeArr=success.data.employee;
        this.filterRecArr=success.data.recruiter;
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onCancel() {

  }
  onSubmit(type) {
    if (this.addForm.invalid) {
      this.addForm.markAllAsTouched();
    }
    else {
      // const data = this.addForm.value;
      const data = {
        "st_dt": this.datePipe.transform(this.addForm.get('st_dt')?.value,"yyyy-MM-dd"),
        "ed_dt":  this.datePipe.transform(this.addForm.get('ed_dt')?.value,"yyyy-MM-dd"),
        "j_c": this.addForm.get('j_c')?.value,
        "j_sc": this.addForm.get('j_sc')?.value,
        // "type":this.addForm.get('type')?.value, // 1 = company/recruiter , 2 = employee
        "arr": [], // selected employee or recruiter's id
        "e_type": type // 1 = csv, 2 = pdf
      }
      if(this.addForm.get('type')?.value=="3"){ // if type 2 then recruiter 
        data["arr"]=this.addForm.get('rec')?.value
      }
      if(this.addForm.get('type')?.value=="2"){ // if type 2 then emp 
        data["arr"]=this.addForm.get('emp')?.value
      }
      if(this.addForm.get('type')?.value=="1"){ //if type 1 then company
        data["arr"]=this.addForm.get('cmp')?.value
      }     
      if(this.addForm.get('type')?.value){
        data["type"]=this.addForm.get('type')?.value
      }
       this.recruiterService.costCalculator(data).subscribe({
        next: (success: any) => {
          if (success.status == 200) {
            this.appService.downloadFile(success.msg.sheet,"cost_calculation")
          }
        },
        error: (error: any) => {
          if(error.status==406){
            this.appService.showToastMessage('error',error.msg)
          }
        }
      })
    
      }
  }
}